import HelpIcon from 'dashboard/components-lib/HelpIcon';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { CaseAnalyticsResolutionsByTag } from 'dashboard/models/case-analytics';
import { CaseTemplateBasicsOptionState } from 'dashboard/models/case-template';
import CaseResolutionsByTagChart from 'dashboard/views/DashboardCaseAnalyticsResolutionsView/CaseResolutionsByTagChart';
import Card from 'design-system/components/Card';

export interface CaseResolutionsByTagCardProps extends CaseAnalyticsResolutionsByTag {
  loading: boolean;
  allStates: CaseTemplateBasicsOptionState[];
}

const CaseResolutionsByTagCard = ({ data, loading, allStates }: CaseResolutionsByTagCardProps) => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>
          Case resolutions by tag
          <HelpIcon popoverWidth={270}>Showing up to the top 14 tags by case volume.</HelpIcon>
        </Card.Title>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <CaseResolutionsByTagChart data={data} allStates={allStates} />
        )}
      </Card.Body>
    </Card>
  );
};

export default CaseResolutionsByTagCard;
